<template>
<div>
  <h2>シフトパターン設定</h2>
  <v-tabs v-model="tab" color="primary">
    <v-tab value="shift">シフトパターン設定</v-tab>
    <v-tab value="work">作業内容設定</v-tab>
  </v-tabs>

  <!-- vue2 
  <v-tabs-items v-model="tab">
    <v-tab-item>
      <shift-pattern-container />
    </v-tab-item>
    <v-tab-item>
      <work-description-container />
    </v-tab-item>
  </v-tabs-items>
  -->
  <v-window v-model="tab">
    <v-window-item value="shift">
      <shift-pattern-container />
    </v-window-item>
    <v-window-item value="work">
      <work-description-container />
    </v-window-item>
  </v-window>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ShiftPatternContainer from '@/containers/work-schedule/ShiftPatternContainer.vue';
import WorkDescriptionContainer from '@/containers/work-schedule/WorkDescriptionContainer.vue';

export default defineComponent({
    data: () => {
        return {
            tab: 'shift',
        };
    },
    components: { 
      ShiftPatternContainer,
      WorkDescriptionContainer
    }
})
</script>